export default 

class Menu {

    constructor(title="", icon="", route="", submenu = []) {
        this.title = title;
        this.icon = icon;
        this.route = route;
        this.submenu = submenu;
    }
}